import getOfferingTypesForRegistrationWithRouteCode from './GetOfferingTypesForRegistrationWithRouteCodeData';

const OfferingTypeWithRouteCodeData = {
  /* INITIAL_STATE, */
  getOfferingTypesForRegistrationWithRouteCode,
  
};

export default OfferingTypeWithRouteCodeData;